import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useAppDispatch as useDispatch } from 'dux/app/hooks';

import { styled } from '@prose-ui/legacy';

import { Button } from 'Components/LegacyButton';
import { SelectField } from 'Components/SelectField';
import TextAreaField from 'Components/TextAreaField';
import { Typography } from 'Components/Typography';

import { trackPostPurchaseSurveyCompleted } from 'dux/tracking/actions';

const Root = styled.div`
  max-width: 327px;
  padding: 35px 0;
`;

const StyledButton = styled(Button)`
  margin-top: 0;
  width: 100%;
`;

const SuccessText = styled(Typography)`
  margin-top: 8px;
`;

const CustomerOriginForm = ({ customerOrigins, onSubmit, success }) => {
  const dispatch = useDispatch();
  const [customerOrigin, setCustomerOrigin] = useState({});

  useEffect(() => {
    if (success) dispatch(trackPostPurchaseSurveyCompleted({ label: customerOrigin.label }));
  }, [success]);

  return (
    <Root>
      {success ? (
        <SuccessText align="left" color="grey" data-testid="origin-success" variant="h3">
          Thanks for letting us know!
        </SuccessText>
      ) : (
        <>
          <Typography align="left" color="noir" paragraph variant="h3">
            How did you hear about us?
          </Typography>

          {/* Dropdown field */}
          <SelectField
            data-testid="origin-select-field"
            id="origin"
            label="Please Select"
            list={customerOrigins.map(({ name, pubkey }) => ({
              label: name,
              value: pubkey,
            }))}
            name="origin"
            onChange={e => {
              return setCustomerOrigin({
                value: e.target.value,
                // Protection against undefined, "option" by default
                label: e.target?.[e.target?.selectedIndex]?.label ?? 'option',
              });
            }}
            value={customerOrigin.value}
          />

          {/* Open text field */}
          {customerOrigin?.label === 'Other' && (
            <TextAreaField
              data-testid="origin-comment-field"
              fullWidth
              id="comment"
              label="Can you tell us more"
              maxWidth
              onChange={e => {
                return setCustomerOrigin({
                  ...customerOrigin,
                  comment: e.target.value,
                });
              }}
              value={customerOrigin?.comment || ''}
            />
          )}

          {/* Submit button */}
          <StyledButton
            data-testid="origin-submit"
            disabled={
              !customerOrigin.value ||
              (customerOrigin?.label === 'Other' && !customerOrigin?.comment)
            }
            onClick={() => onSubmit(customerOrigin)}
            variant="vert"
          >
            Submit
          </StyledButton>
        </>
      )}
    </Root>
  );
};

CustomerOriginForm.propTypes = {
  customerOrigins: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired,
};

export default CustomerOriginForm;
